export const ORG_BILDTVAPP = "BILDTVAPP";
export const DEFAULT_BRAND_SETTING: BrandSettings = {
  id: "default",
  theme: "default",
};

export type BrandSettings = {
  id: string;
  theme: string;
  twitterHandle?: string;
};

export type Organization = BrandSettings & {
  categories?: BrandSettings[];
};

export const organizations: Organization[] = [
  {
    id: "WELT",
    theme: "welt",
    twitterHandle: "welt",
    categories: [{ id: "icon", theme: "icon", twitterHandle: "ICONISTbyicon" }],
  },
  { id: "BILD", theme: "bild", twitterHandle: "bild" },
  {
    id: "BILD-BOOKS",
    theme: "default",
    categories: [
      {
        id: "travelbook",
        theme: "bild_travelbook",
        twitterHandle: "travelbook_de",
      },
      {
        id: "fitbook",
        theme: "bild_fitbook",
        twitterHandle: "fitbook_de",
      },
      {
        id: "stylebook",
        theme: "bild_stylebook",
        twitterHandle: "stylebook_de",
      },
      {
        id: "techbook",
        theme: "bild_techbook",
        twitterHandle: "techbook",
      },
      {
        id: "myhomebook",
        theme: "bild_myhomebook",
        twitterHandle: "myhomebook_de",
      },
    ],
  },
  { id: "AUBI", theme: "aubi", twitterHandle: "autobild" },
  { id: "COBI", theme: "cobi", twitterHandle: "COMPUTERBILD" },
  { id: "SPOBI", theme: "spobi", twitterHandle: "SPORTBILD" },
  { id: "BZ", theme: "bild", twitterHandle: "bz" },
  {
    id: "BRANDSTUDIO",
    theme: "default",
    categories: [
      {
        id: "bild-brand",
        theme: "bild_brandstory",
        twitterHandle: "bild",
      },
      {
        id: "bild-product-advertorial",
        theme: "bild_productstory",
        twitterHandle: "bild",
      },
      {
        id: "books-travelbook-brand",
        theme: "bild_travelbook",
        twitterHandle: "travelbook_de",
      },
      {
        id: "books-fitbook-brand",
        theme: "bild_fitbook",
        twitterHandle: "fitbook_de",
      },
      {
        id: "books-stylebook-brand",
        theme: "bild_stylebook",
        twitterHandle: "stylebook_de",
      },
      {
        id: "books-techbook-brand",
        theme: "bild_techbook",
        twitterHandle: "techbook",
      },
      {
        id: "books-myHomebook-brand",
        theme: "bild_myhomebook",
        twitterHandle: "myhomebook_de",
      },
      {
        id: "welt-brand",
        theme: "welt_brandstory",
        twitterHandle: "welt",
      },
      {
        id: "welt-product-advertorial",
        theme: "welt_productstory",
        twitterHandle: "welt",
      },
      {
        id: "manschaftsbus",
        theme: "manschaftsbus",
      },
    ],
  },
  {
    id: "MEDIAPIONEER",
    theme: "mediapioneer",
    twitterHandle: "mediapioneercom",
  },
  {
    id: "MUSIKEXPRESS",
    theme: "musikexpress",
    twitterHandle: "musikexpressde",
  },
  { id: ORG_BILDTVAPP, theme: "bild", twitterHandle: "bild" },
  {
    id: "ROLLINGSTONE",
    theme: "rollingstone",
    twitterHandle: "rollingstoneDE",
  },
  {
    id: "METALHAMMER",
    theme: "metalhammer",
    twitterHandle: "metalhammer_de",
  },
];

export const getBrand = (
  organizationId: string,
  categoryId?: string
): BrandSettings => {
  const organization = organizations.find(
    (organization: Organization) =>
      organization.id === organizationId.toUpperCase()
  );

  if (organization && categoryId) {
    const category = organization.categories?.find(
      (category: BrandSettings) => category.id === categoryId.toLowerCase()
    );
    return category ?? organization;
  }

  return organization ?? DEFAULT_BRAND_SETTING;
};
